/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { setIsPrimaryAnimatedSideBarOpen, setPrimarySideBarDataTag, setSecondarySideBarDataTag } from '../../ducks/calendarActions';

const SideBarWrapper = styled('div')`
  background-color: white;
  width: 48px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0px 4px 8px 0px #3031331A;
  z-index: 100;

  ${(props) => props.viewType === 'weekView' && 'position: fixed;'}
  ${(props) => props.viewType === 'weekView' && 'left: 0;'}
  ${(props) => props.viewType === 'weekView' && 'height: 100%;'}
`;

const IconToggleBox = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 48px;
  max-width: 48px;
  min-height: 40px;
  max-height: 40px;
  border-right: ${(props) => (props.activeToggle ? '2px solid #444444' : '2px solid white')};
  cursor: pointer;
  transition: all 250ms ease-in-out;
  :hover {
    opacity: 0.7;
  }
`;

const IconSideBar = () => {
  const dispatch = useDispatch();
  const isPrimaryAnimatedSideBarOpen = useSelector((state) => state.calendar.data.isPrimaryAnimatedSideBarOpen);
  const primarySideBarDataTag = useSelector((state) => state.calendar.data.primarySideBarDataTag);
  const programType = useSelector((state) => state.calendar.data.programType);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const iconArray = programType === 'free-form-program' ? ['note', 'lift', 'templates'] : ['calendar2', 'lift', 'templates'];

  useEffect(() => {
    if (!isPrimaryAnimatedSideBarOpen) {
      dispatch(setPrimarySideBarDataTag(null));
      dispatch(setSecondarySideBarDataTag(null));
    }
  }, [isPrimaryAnimatedSideBarOpen, dispatch]);

  return (
    <SideBarWrapper viewType={viewType}>
      {iconArray.map((icon) => {
        if (viewType === 'monthView' && icon === 'lift') {
          return null;
        }
        return (
          <IconToggleBox
            onClick={() => {
              dispatch(setIsPrimaryAnimatedSideBarOpen(primarySideBarDataTag !== icon));
              /** set timeout to wait for transition then set datatag */
              if (primarySideBarDataTag !== icon && !isPrimaryAnimatedSideBarOpen) {
                setTimeout(() => {
                  dispatch(setPrimarySideBarDataTag(icon));
                }, 250);
              } else {
                dispatch(setPrimarySideBarDataTag(icon));
              }
            }}
            activeToggle={primarySideBarDataTag === icon}
          >
            <IcomoonReact
              iconSet={iconSet}
              size={20}
              icon={icon}
              color={primarySideBarDataTag === icon ? '#444444' : '#9E9E9E'}
            />
          </IconToggleBox>
        );
      })}
    </SideBarWrapper>
  );
};

export default IconSideBar;
